import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';

const key = () => ['houseRegistrationTypes'];

const fetchTypes = async () => {
  const res = await request.get(
    `/HousingStock/registration_types`,
    {},
    'Не удалось загрузить типы регистраций'
  );

  return res;
};

const useHouseRegistrationTypes = (options) => {
  const query = useQuery(key(), fetchTypes, options);
  return {
    data: query.data,
    loading: query.isLoading
  }
}

export { key as houseRegistrationTypesKey, useHouseRegistrationTypes };
